var messages = {
  currentDate: '当前日期'
};
export default messages;